import React from 'react';
import cx from 'classnames';

import type {Quality} from '@pexip/peer-connection-stats';

import type {SelfviewProps} from '../Selfview.view';
import {AspectRatioSelfview} from '../AspectRatioSelfview/AspectRatioSelfview';

import {InMeetingSelfviewHeader} from './InMeetingSelfviewHeader.view';
import {InMeetingSelfviewFooter} from './InMeetingSelfviewFooter.view';

import styles from './InMeetingSelfview.module.scss';

export const InMeetingSelfview: React.FC<
    SelfviewProps & {
        quality: Quality;
        callQualityPosition: 'topRight' | 'bottomRight';
        overlayClassName?: string;
        isAudioInputMuted?: boolean;
        isAudioInputMissing?: boolean;
        isMobileDevice?: boolean;
        areEffectsEnabled: boolean;
        areEffectsApplied: boolean;
        onCollapseSelfview: () => void;
        onToggleAudioClick: () => void;
        toggleFacingMode?: () => void;
        openEffectsModal: () => void;
    }
> = ({
    overlayClassName,
    isAudioInputMuted,
    isAudioInputMissing,
    isMobileDevice,
    quality,
    areEffectsEnabled,
    areEffectsApplied,
    onCollapseSelfview,
    onToggleAudioClick,
    toggleFacingMode,
    openEffectsModal,
    ...props
}) => (
    <AspectRatioSelfview
        isMobileDevice={isMobileDevice}
        aspectRatioType="in-meeting"
        overlayClassName={cx(styles.selfviewOverlay, overlayClassName)}
        {...props}
    >
        <InMeetingSelfviewHeader
            onClick={onCollapseSelfview}
            isMobileDevice={isMobileDevice}
        />
        <InMeetingSelfviewFooter
            isAudioInputMuted={isAudioInputMuted}
            isAudioInputMissing={isAudioInputMissing}
            isMobileDevice={isMobileDevice}
            quality={quality}
            areEffectsEnabled={areEffectsEnabled}
            areEffectsApplied={areEffectsApplied}
            onToggleAudioClick={onToggleAudioClick}
            toggleFacingMode={toggleFacingMode}
            openEffectsModal={openEffectsModal}
        />
    </AspectRatioSelfview>
);

export type InMeetingSelfviewProps = React.ComponentProps<
    typeof InMeetingSelfview
>;
